import { Languages } from '@space-shell/constant/languages'
import en from '@space-shell/core/locales/en.json'
import type { InitOptions } from 'i18next'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

export const config: InitOptions = {
  debug: process.env.TARGET_ENV === 'development',
  resources: { en: { translation: en } },
  load: 'currentOnly',
  fallbackLng: Languages.En,
  interpolation: {
    escapeValue: false
  },
  detection: {
    order: ['cookie', 'path'],
    lookupCookie: 'hmLangCookie'
  }
}

i18n.use(initReactI18next).init(config)

export default i18n
